<template>
  <el-container>
    <el-header class="my-el-header" :style="computedStyle" v-show="$route.path.indexOf('/auth/APIAuth') == -1">
      <div class="header">
        <div class="jzq-logo">
          <img src="/images/logo/jzq-logo.png" width="300px" />
        </div>
        <!-- 钉钉新开标签有【_black】标识，不展示返回首页按钮 -->
        <div class="right-position" @click="toIndex" v-show="isInDingTalk && $route.path.indexOf('/auth/dingTalkAuth') == -1">
          <i class="el-icon-d-arrow-left"></i>
          返回首页
        </div>
      </div>
    </el-header>
    <div class="y-header" style="height: 60px"></div>
    <el-main :style="{ 'min-height': height }">
      <nuxt />
    </el-main>
  </el-container>
</template>

<script>
import { isInDingTalk } from '../assets/js/utils/ding-env';
import {ding_erformance} from "./js/entConsoleDate.js"
export default {
  data () {
    return {
      height: "835px",
      isInDingTalk
    };
  },
  computed: {
    computedStyle() {
      return this.$store.getters.get_computedStyle;
    },
  },
  mounted () {
    this.height = document.body.clientHeight - 100 + "px";
    ding_erformance()
  },
  methods: {
    toIndex () {
      if (isInDingTalk) {
        this.$router.replace({ path: '/viewIndex' })
      }
    },
  },
  name: "fullpage"
};
</script>

<style lang="less" scoped>
.my-el-header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  /*z-index: 2;*/
  z-index: 500;
  height: 60px !important;
  background-color: #ec1c1c;
  color: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(38, 38, 38, 0.35);
}

.header {
  position: relative;
  margin: 0 auto;
  .jzq-logo {
    height: 60px;
    line-height: 60px;
  }
  .right-position {
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// layouts/fullpage.vue